import { storeWrapper } from '../storeWrapper'
import { debounce } from '@repo/utils/debounce'
import { ospreyAPI } from '@repo/api/ospreyAPI'

const initialState = {
  clientProfile: {},
  clientNo: null
}

export const useClientProfileStore = storeWrapper('useClientProfileStore', (set) => ({
  ...initialState,
  fetchClientProfile: async ({ clientNo }) => {
    return new Promise((resolve) => {
      debounce({
        id: `fetchClientProfile_${clientNo}`,
        delay: 500,
        callback: async () => {
          let fetchedClientProfile

          try {
            fetchedClientProfile =
              (await ospreyAPI({
                service: 'matters',
                endpoint: 'Client/GetClientProfile',
                data: { clientNo: clientNo }
              })) || {}
          } catch (err) {
            console.log('Error:', err)
            return
          }

          set({ clientProfile: fetchedClientProfile })
          resolve(fetchedClientProfile)
        }
      })
    })
  },
  reset: () => set(initialState)
}))
